import {AdminProductParamResponse, ChargeModeType} from 'api/productApi'
/* eslint-disable import/prefer-default-export */
export const TYPE_INDICATOR_PRODUCT = {
  HOSPITAL: 'Medical',
  HEALTH: 'HealthCare',
  ALL: 'Common',
} as const

export type TypeIndicatorProduct =
  (typeof TYPE_INDICATOR_PRODUCT)[keyof typeof TYPE_INDICATOR_PRODUCT]

export type TypeIndicator =
  (typeof TYPE_INDICATOR_PRODUCT)[keyof typeof TYPE_INDICATOR_PRODUCT]

export const TARGET_TYPE = {
  ORG_TYPE: 'OrgType',
  REGION: 'Region',
  ORG_ID: 'OrgId',
}

export const TARGET_ORG_TYPE = {
  HEALTH: 'Healthcare',
  HOSPITAL: 'Hospital',
}

export const SEARCH_VALUE_TYPE_BY_ORG = {
  ORG_NAME: 'ORG_NAME',
  EMAIL: 'EMAIL',
  GOODS_NAME: 'GOODS_NAME',
}

export type SearchValueTypeOrg =
  (typeof SEARCH_VALUE_TYPE_BY_ORG)[keyof typeof SEARCH_VALUE_TYPE_BY_ORG]

export const PAYMENT_TYPE_BY_ORG = {
  PREPAID_ONCE: 'PREPAID_ONCE',
  PREPAID_MONTHLY: 'PREPAID_MONTHLY',
  MANUAL: 'MANUAL',
}

export type PaymentTypeOrg =
  (typeof TARGET_ORG_TYPE)[keyof typeof TARGET_ORG_TYPE]

export const ORG_ID_APPOINT = 'APPOINT'

export type TargetSaleType = (typeof TARGET_TYPE)[keyof typeof TARGET_TYPE]

export const TYPE_INDICATOR_PRODUCT_OPTIONS_HEALTH = [
  {
    key: TYPE_INDICATOR_PRODUCT.HOSPITAL,
    label: 'IClinicAndHospital',
  },
  {
    key: TYPE_INDICATOR_PRODUCT.HEALTH,
    label: 'IExaminationCenter',
  },
  {
    key: TYPE_INDICATOR_PRODUCT.ALL,
    label: 'IAll',
  },
]

export const TYPE_INDICATOR_PRODUCT_OPTIONS_NORMAL = [
  {
    key: TYPE_INDICATOR_PRODUCT.HOSPITAL,
    label: 'IClinicAndHospital',
  },
]

export const PBM_CARE = {
  MINUTES: 'Minute',
  CASE: 'Count',
}

export const PBM_OPTIONS = [
  {
    name: 'IMinutes',
    id: PBM_CARE.MINUTES,
  },
]

export const TARGET_NATION_ITEM = {
  ADMIN_DESIGN_AGENCY: 'AdminDesign',
}

export const TARGET_NATION_SELECT = [
  {
    name: 'IAdminDesignAgency',
    id: TARGET_NATION_ITEM.ADMIN_DESIGN_AGENCY,
  },
]

export const PREPAYMENT_ITEM = {
  PROVIDER: 'Once',
  MONTHLY_OFFER: 'Monthly',
}

export const CHARGING_ITEM = {
  INDIVIDUAL: 'Each' as ChargeModeType,
  BATCH: 'All' as ChargeModeType,
}

export const PREPAYMENT_SELECT = [
  {
    name: 'IProvideBulk',
    id: PREPAYMENT_ITEM.PROVIDER,
  },
  {
    name: 'IMonthlyOffer',
    id: PREPAYMENT_ITEM.MONTHLY_OFFER,
  },
]

export const CHARGING_METHOD = [
  {
    name: 'IIndividualCharging',
    id: CHARGING_ITEM.INDIVIDUAL,
  },
  {
    name: 'IBatchCharging',
    id: CHARGING_ITEM.BATCH,
  },
]

export type Prepayment = (typeof PREPAYMENT_ITEM)[keyof typeof PREPAYMENT_ITEM]

export const FORM_DATA_TABLE = [
  {
    groupName: 'EEG',
    products: [
      // {
      //   id: 1,
      //   key: 'individual_common',
      //   select: false,
      //   nameProduct: 'IProductIndividualAnalysis',
      //   unitPriceWon: 10000,
      //   unitPriceDollar: 10,
      //   paidPoints: 100,
      //   deductionPoints: 10,
      //   remark: '비고',
      // },
      {
        id: 2,
        key: 'individual_3d_common',
        select: true,
        nameProduct: 'IProductIndividualAnalysis3D',
        unitPriceWon: 15000,
        unitPriceDollar: 15,
        paidPoints: 150,
        deductionPoints: 15,
        remark: '비고',
      },
      {
        id: 3,
        key: 'mapping_basic_clinic',
        select: false,
        nameProduct: 'IProductMappingBasic',
        unitPriceWon: 20000,
        unitPriceDollar: 20,
        paidPoints: 200,
        deductionPoints: 20,
        remark: '비고',
      },
      {
        id: 4,
        key: 'mapping_advanced_clinic',
        select: false,
        nameProduct: 'IProductMappingAdvanced',
        unitPriceWon: 25000,
        unitPriceDollar: 25,
        paidPoints: 250,
        deductionPoints: 25,
        remark: '비고',
      },
      {
        id: 5,
        key: 'brain_5features_clinic',
        select: false,
        nameProduct: 'IProductBrain5Features',
        unitPriceWon: 30000,
        unitPriceDollar: 30,
        paidPoints: 300,
        deductionPoints: 30,
        remark: '비고',
      },
      {
        id: 6,
        key: 'brain_connectivity_clinic',
        select: false,
        nameProduct: 'IProductBrainConnectivity',
        unitPriceWon: 35000,
        unitPriceDollar: 35,
        paidPoints: 350,
        deductionPoints: 35,
        remark: '비고',
      },
      {
        id: 7,
        key: 'mci_clinic',
        select: false,
        nameProduct: 'IProductMCIClinic',
        unitPriceWon: 40000,
        unitPriceDollar: 40,
        paidPoints: 400,
        deductionPoints: 40,
        remark: '비고',
      },
      {
        id: 8,
        key: 'normdb_clinic',
        select: false,
        nameProduct: 'IProductNormDBClinic',
        unitPriceWon: 45000,
        unitPriceDollar: 45,
        paidPoints: 450,
        deductionPoints: 45,
        remark: '비고',
      },
      {
        id: 9,
        key: 'normdb_3d_clinic',
        select: false,
        nameProduct: 'IProductNormDB3DClinic',
        unitPriceWon: 50000,
        unitPriceDollar: 50,
        paidPoints: 500,
        deductionPoints: 50,
        remark: '비고',
      },
    ],
  },
  {
    groupName: 'MCI',
    products: [
      {
        id: 10,
        key: 'mci_clinic',
        select: false,
        nameProduct: 'IProductMCIClinic',
        unitPriceWon: 40000,
        unitPriceDollar: 40,
        paidPoints: 400,
        deductionPoints: 40,
        remark: '비고',
      },
    ],
  },
  {
    groupName: 'HRV',
    products: [
      // {
      //   id: 11,
      //   key: 'individual_common',
      //   select: false,
      //   nameProduct: 'IProductIndividualAnalysis',
      //   unitPriceWon: 10000,
      //   unitPriceDollar: 10,
      //   paidPoints: 100,
      //   deductionPoints: 10,
      //   remark: '비고',
      // },
      {
        id: 12,
        key: 'summary_basic_clinic',
        select: false,
        nameProduct: 'IProductSummaryBasicClinic',
        unitPriceWon: 22000,
        unitPriceDollar: 22,
        paidPoints: 220,
        deductionPoints: 22,
        remark: '비고',
      },
      {
        id: 13,
        key: 'summary_advanced_clinic',
        select: false,
        nameProduct: 'IProductSummaryAdvancedClinic',
        unitPriceWon: 32000,
        unitPriceDollar: 32,
        paidPoints: 320,
        deductionPoints: 32,
        remark: '차감 단위 "건" 인 경우, 분--> 건으로 변경 됨',
      },
    ],
  },
  {
    groupName: 'PBM',
    products: [
      {
        id: 14,
        key: 'pbm_care_common',
        select: false,
        nameProduct: 'IProductPbm',
        unitPriceWon: 28000,
        unitPriceDollar: 28,
        paidPoints: 280,
        deductionPoints: 28,
        remark: '비고',
        unitPbm: PBM_CARE.MINUTES,
      },
    ],
  },
]

export const TABLE_HEADER_DETAIL = (t: any) => [
  {
    id: 0,
    label: t('IDivision'),
    key: 'division',
    width: 110,
  },
  {
    id: 1,
    label: t('IGroup'),
    key: 'group',
    width: 100,
  },
  {
    id: 2,
    label: t('ISelectCustomer'),
    key: 'select',
    width: 50,
  },
  {
    id: 3,
    label: t('ICharacteristic'),
    key: 'characteristic',
    width: 146,
  },
  {
    id: 4,
    label: t('IUnitPriceExtra', {value: '₩'}),
    key: 'unitPriceWon',
    width: 150,
  },
  {
    id: 5,
    label: t('IUnitPriceExtra', {value: '$'}),
    key: 'unitPriceDollar',
    width: 150,
  },
  {
    id: 6,
    label: t('IPaidPoints'),
    key: 'paidPoints',
    width: 100,
  },
  // {
  //   id: 7,
  //   label: t('IDeductionPoints'),
  //   key: 'deductionPoints',
  //   width: 146,
  // },
  {
    id: 8,
    label: t('IRemark'),
    key: 'remark',
    width: 146,
  },
]

export const PAYMENT_METHOD = {
  PREPAYMENT: 'Prepaid',
  POST_SETTLEMENT: 'Postpaid',
  MANUAL: 'ManualPaid',
  SUBSCRIPTION: 'Subscription',
} as const

export type PaymentMethod = (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD]

export const PAYMENT_METHOD_OPTIONS = [
  {key: PAYMENT_METHOD.PREPAYMENT, label: 'IChargeMonthlyInstallment'},
  // {key: PAYMENT_METHOD.POST_SETTLEMENT, label: 'IPostSettlement'},
  {key: PAYMENT_METHOD.MANUAL, label: 'IManual'},
  // {key: PAYMENT_METHOD.SUBSCRIPTION, label: 'ISubscriptionMethod'},
]

export const TARGET_NATION = {
  DOMESTIC: 'Domestic',
  OVERSEAS: 'Overseas',
  ALL: 'all',
} as const

export type TargetNation = (typeof TARGET_NATION)[keyof typeof TARGET_NATION]
export type TargetNationOrg =
  (typeof TARGET_NATION_ITEM)[keyof typeof TARGET_NATION_ITEM]

export const TARGET_NATION_OPTIONS = [
  {key: TARGET_NATION.DOMESTIC, label: 'IDomestic'},
  {key: TARGET_NATION.OVERSEAS, label: 'IOverseas'},
  {key: TARGET_NATION.ALL, label: 'IAll'},
]

export interface FormProductComposition {
  paymentMethod: PaymentMethod
  nameProductKo: string
  nameProductEn: string
  targetNation: TargetNation
  targetNationOrg: TargetNationOrg
  prepayment: Prepayment
}

export const FORM_PRODUCT_COMPOSITION: FormProductComposition = {
  paymentMethod: PAYMENT_METHOD.PREPAYMENT,
  nameProductKo: '',
  nameProductEn: '',
  targetNation: TARGET_NATION.DOMESTIC,
  targetNationOrg: TARGET_NATION_ITEM.ADMIN_DESIGN_AGENCY,
  prepayment: PREPAYMENT_ITEM.PROVIDER,
}

export const USAGE_PERIOD_UNIT = {
  DAY: 'Day',
  MONTH: 'Month',
  YEAR: 'Year',
  LIFETIME: 'Lifetime',
  DATE: 'Date',
}

export const SALE_STATUS = {
  READY: 'Ready',
  ON_SALE: 'OnSale',
  OFF_SALE: 'OffSale',
}

export type SaleStatus = (typeof SALE_STATUS)[keyof typeof SALE_STATUS]

export type UsagePeriodUnitType =
  (typeof USAGE_PERIOD_UNIT)[keyof typeof USAGE_PERIOD_UNIT]

export const OFFER_TYPE = {
  MONTHLY: 'Monthly',
  ANUAL: 'Annual',
  ONCE: 'Once',
}

export type OffersType = (typeof OFFER_TYPE)[keyof typeof OFFER_TYPE]

export const UNIT_PRICES = {
  KRW: 'KRW',
  USD: 'USD',
} as const

export const ORDER_PAYMENT_METHOD = {
  CREDIT_CARD: 'CreditCard',
  BANK_TRANSFER: 'BankTransfer',
  MOBILE_PAYMENT: 'MobilePayment',
  PAY_PAL: 'PayPal',
}

export type KeyPrices = (typeof UNIT_PRICES)[keyof typeof UNIT_PRICES]
export type KeyPayment =
  (typeof ORDER_PAYMENT_METHOD)[keyof typeof ORDER_PAYMENT_METHOD]

export const PRODUCT_DATA_INIT: AdminProductParamResponse = {
  offer: {
    usagePeriodUnit: USAGE_PERIOD_UNIT.MONTH,
    usagePeriod: 12,
    offerType: 'Monthly',
    offerItems: [
      {
        offerUnit: 'Count',
        offerAmount: 0,
        unitPrices: [
          {
            currency: UNIT_PRICES.KRW,
            price: 0,
          },
          {
            currency: UNIT_PRICES.USD,
            price: 0,
          },
        ],
        pkgItemId: '',
      },
    ],
  },
  sale: {
    prices: [
      {
        currency: UNIT_PRICES.KRW,
        price: 0,
      },
      {
        currency: UNIT_PRICES.USD,
        price: 0,
      },
    ],
    discountRate: 0,
    salePrices: [
      {
        currency: UNIT_PRICES.KRW,
        price: 0,
      },
      {
        currency: UNIT_PRICES.USD,
        price: 0,
      },
    ],
    paymentMethod: PAYMENT_METHOD.PREPAYMENT,
    saleTarget: {
      targetOp: 'And',
      targets: [
        {
          targetType: 'OrgType',
          targetId: 'Hospital',
        },
        {
          targetType: 'Region',
          targetId: TARGET_NATION.DOMESTIC,
        },
      ],
    },
    chargeMode: 'Each',
    chargeQuantity: 0,
  },
  goods: {
    displayInfos: [
      {
        langCode: 'en',
        name: '',
        description: '',
        imageUrl: '',
      },
      {
        langCode: 'ko',
        name: '',
        description: '',
        imageUrl: '',
      },
    ],
  },
}
export const CUSTOMER_EXPOSURE = {
  ACTIVE: 'active',
  NON_ACTIVE: 'non-active',
} as const

export type CustomerExposure =
  (typeof CUSTOMER_EXPOSURE)[keyof typeof CUSTOMER_EXPOSURE]

export const CUSTOMER_EXPOSURE_OPTIONS = [
  {key: CUSTOMER_EXPOSURE.ACTIVE, label: 'IOperating'},
  {key: CUSTOMER_EXPOSURE.NON_ACTIVE, label: 'INonOperating'},
]

export interface FormTotalPrice {
  wonPrice: number
  wonSale: number
  wonFinalPrice: number
  dollarPrice: number
  dollarSale: number
  dollarFinalPrice: number
  periodPrice: number
  unlimitPeriod: boolean
  note: string
  descriptionKo: string
  descriptionEn: string
  discountRate: number
}

export type ProductDataType = {
  id: number
  number: number
  productName: string
  salesAmount: number
  targetOrganization: string
  type: string
  targetOrganization1: string
  usePeriod: string
  customerExposure: string
  explanation: string
}

export type ProductListType = {
  id: number
  label: string
  key: string
}

interface ChargeTableColumn {
  id: number
  label: string
  key:
    | 'division'
    | 'analysisIndicators'
    | 'amount'
    | 'remainingNumber'
    | 'numberOfCharges'
}

export const PRODUCT_MANAGEMENT_TABLE_HEADER: ProductListType[] = [
  {
    id: 0,
    label: 'ICustomerNumber',
    key: 'goodsId',
  },
  {
    id: 1,
    label: '',
    key: 'dragHandle',
  },
  {
    id: 2,
    label: 'IProductNameV1',
    key: 'goodsName',
  },
  {
    id: 3,
    label: 'ISalesAmount',
    key: 'salePrice',
  },
  {
    id: 4,
    label: 'ITargetOrganization',
    key: 'targetOp',
  },
  {
    id: 5,
    label: 'IType',
    key: 'paymentMethod',
  },
  {
    id: 6,
    label: 'ITargetNation',
    key: 'targetNation',
  },
  {
    id: 7,
    label: 'IUsePeriod',
    key: 'usagePeriod',
  },
  {
    id: 8,
    label: 'ICustomerExposure',
    key: 'saleStatus',
  },
  {
    id: 9,
    label: 'IDescription',
    key: 'goodsDescription',
  },
  {
    id: 10,
    label: 'IInquirySelect',
    key: 'inquirySelect',
  },
]

export const PRODUCT_TABLE_DATA: ProductDataType = {
  id: 0,
  number: 1,
  productName: 'AI Brain Scan Basic',
  salesAmount: 100000,
  targetOrganization: '검진 센터',
  type: '후 정산',
  targetOrganization1: '검진 센터',
  usePeriod: '무 제한',
  customerExposure: 'Y',
  explanation: '',
}

export const PRODUCT_MANAGEMENT_TABLE_DATA = [PRODUCT_TABLE_DATA]

export const PACKAGE_ID_HIDDEN = ['1', '8']

export const CHARGE_TABLE_DATA: ChargeTableColumn[] = [
  {
    id: 0,
    label: 'IDivision',
    key: 'division',
  },
  {
    id: 1,
    label: 'IAnalysisIndicatorsV1',
    key: 'analysisIndicators',
  },
  {
    id: 2,
    label: 'IAmount',
    key: 'amount',
  },
  {
    id: 3,
    label: 'IRemainingNumber',
    key: 'remainingNumber',
  },
  {
    id: 4,
    label: 'INumberOfCharges',
    key: 'numberOfCharges',
  },
]

export const DEFAULT_ZERO_QUANTITY = 0

export const DEFAULT_ONE_QUANTITY = 1

export const PURCHASE_LIMIT = 2

export const TYPE_DELIVERY_STATUS = {
  PENDING: 'PENDING',
  DELIVERING: 'DELIVERING',
  COMPLETED: 'COMPLETED',
  RETURNING: 'RETURNING',
  RETURNED: 'RETURNED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const

export type TypeDeliveryStatus =
  (typeof TYPE_DELIVERY_STATUS)[keyof typeof TYPE_DELIVERY_STATUS]

export const TYPE_GOOD_TYPE = {
  PACKAGE: 'PACKAGE',
  CHARGE: 'CHARGE',
} as const

export type TypeGoodsType = (typeof TYPE_GOOD_TYPE)[keyof typeof TYPE_GOOD_TYPE]

// ===== Order Status =====
export const TYPE_ORDER_STATUS = {
  CREATED: 'CREATED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  DELIVERY_PENDING: 'DELIVERY_PENDING',
  DELIVERING: 'DELIVERING',
  COMPLETED: 'COMPLETED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  REFUND_PENDING: 'REFUND_PENDING',
  PARTIALLY_REFUND_REQUESTED: 'PARTIALLY_REFUND_REQUESTED',
  PARTIALLY_REFUND_PENDING: 'PARTIALLY_REFUND_PENDING',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  REFUNDED: 'REFUNDED',
  REFUND_FAILED: 'REFUND_FAILED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const

export type TypeOrderStatus =
  (typeof TYPE_ORDER_STATUS)[keyof typeof TYPE_ORDER_STATUS]

// ===== Payment Status =====
export const TYPE_PAYMENT_STATUS = {
  CREATED: 'CREATED',
  REQUESTED: 'REQUESTED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING',
  ONGOING: 'ONGOING',
  FAILED: 'FAILED',
  APPROVED: 'APPROVED',
  APPROVED_INVALID: 'APPROVED_INVALID',
  REQUEST_REFUND: 'REQUEST_REFUND',
  PENDING_REFUND: 'PENDING_REFUND',
  REFUNDED: 'REFUNDED',
  FAILED_REFUND: 'FAILED_REFUND',
} as const

export type TypePaymentStatus =
  (typeof TYPE_PAYMENT_STATUS)[keyof typeof TYPE_PAYMENT_STATUS]

// ===== Cancellation Status =====
export const TYPE_CANCELLATION_STATUS = {
  READY: 'READY',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const

export type TypeCancellationStatus =
  (typeof TYPE_CANCELLATION_STATUS)[keyof typeof TYPE_CANCELLATION_STATUS]

// ===== Payment Type =====
export const TYPE_PAYMENT_TYPE = {
  CreditCard: 'CreditCard',
  BankTransfer: 'BankTransfer',
  MobilePayment: 'MobilePayment',
  PayPal: 'PayPal',
} as const

export type TypePaymentType =
  (typeof TYPE_PAYMENT_TYPE)[keyof typeof TYPE_PAYMENT_TYPE]

// ===== Payment Channel =====
export const TYPE_PAYMENT_CHANNEL = {
  ADMIN: 'ADMIN',
  PG: 'PG',
} as const

export type TypePaymentChannel =
  (typeof TYPE_PAYMENT_CHANNEL)[keyof typeof TYPE_PAYMENT_CHANNEL]

export const DEFAULT_SALE_TARGET = {
  targetOp: 'And',
  targets: [],
}

export const ALL_SALE_TARGET = {
  targetOp: 'Or',
  targets: [
    {
      targetType: TARGET_TYPE.ORG_TYPE,
      targetId: TARGET_ORG_TYPE.HOSPITAL,
    },
    {
      targetType: TARGET_TYPE.ORG_TYPE,
      targetId: TARGET_ORG_TYPE.HEALTH,
    },
    {
      targetType: TARGET_TYPE.REGION,
      targetId: TARGET_NATION.DOMESTIC,
    },
    {
      targetType: TARGET_TYPE.REGION,
      targetId: TARGET_NATION.OVERSEAS,
    },
  ],
}

export const ORG_TYPE = {
  HEALTH: 'HEALTH',
  NORMAL: 'NORMAL',
}

export type TypeOrgType = (typeof ORG_TYPE)[keyof typeof ORG_TYPE]

export const TABLE_HEADER_PURCHASE_HISTORY = (t: any) => [
  {
    id: 0,
    label: t('IProductNameSelect'),
    key: 'orderTitle',
    width: 310,
  },
  {
    id: 1,
    label: t('IProductClassification'),
    key: 'productCategory',
    width: 80,
  },
  {
    id: 2,
    label: t('IPeriod'),
    key: 'period',
    width: 80,
  },
  {
    id: 3,
    label: t('IAmount'),
    key: 'priceAmount',
    width: 100,
  },
  {
    id: 4,
    label: t('IStatus'),
    key: 'status',
    width: 150,
  },
]

export const statusList = [
  {value: 'ALL', label: 'IAll'},
  {value: TYPE_PAYMENT_STATUS.PENDING, label: 'IWriting'},
  {value: TYPE_PAYMENT_STATUS.APPROVED, label: 'IComplete'},
  {value: TYPE_PAYMENT_STATUS.REFUNDED, label: 'ICancel'},
]

export const TYPE_REASON_CODE = {
  PAYMENT_APPROVAL: 'PaymentApproval',
  PAYMENT_REFUND: 'PaymentRefund',
  ASSIGN_BY_ADMIN: 'AssignByAdmin',
  PAYMENT_FREE: 'PaymentFree',
  COMPENSATION: 'Compensation',
  ADJUSTMENT: 'Adjustment',
  OTHER: 'Other',
}

export type TypeReasonCode =
  (typeof TYPE_REASON_CODE)[keyof typeof TYPE_REASON_CODE]

export const HOSPITAL_INDICATOR_IDS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '27',
  '28',
  '29',
]

export const EEG_INDICATOR_ID = '1'
export const EEG_INDICATOR_3D_ID = '2'
export const EEG_SUMMARY_ID = '3'
export const EEG_SUMMARY_ADVANCED_ID = '4'
export const MCI_INDICATOR_ID = '5'
export const MCI_CLINIC_INDICATOR_ID = '6'
export const EEG_DEMENTIA_PREDICTION_5_ID = '7'
export const EEG_DEMENTIA_PREDICTION_8_ID = '29'
export const HRV_INDICATOR_ID = '8'
export const HRV_SUMMARY_ID = '9'
export const HRV_SUMMARY_ADVANCED_ID = '10'
export const EEG_FIVE_INDICATOR_ID = '27'
export const EEG_BRAIN_CONNECTIVITY_ID = '28'
export const PBM_INDICATOR_ID = '11'
